import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../shared/components';
import BasicRadioGroup from '../../../../shared/components/BasicRadioGroup';
import { BasicNotification } from '../../../../shared/components/Notification';
import { findMapId, findMapped } from '../../../../shared/misc/utils';
import ActionPlanContext from './ActionPlanContext';

interface Props {
  handleSubmit: (language: string) => void;
}
const NewActionPlan: React.FC<Props> = ({ handleSubmit }) => {
  const { t } = useTranslation();
  const languages = ['en', 'es', 'fr', 'pt'];
  const [lang, setLang] = useState<string | null>(null);
  const radItems = languages
    .map((l, i) => ({ id: i, text: t(`languageCodes.${l}`), htmlId: `rad${l}`, mapped: l }))
    .sort((a, b) => {
      if (a.text > b.text) {
        return 1;
      }
      if (a.text < b.text) {
        return -1;
      }
      return 0;
    });
  const setLanguage = (radId: number) => {
    const value = findMapped(radItems, radId);
    setLang(value);
  };
  const { supervisionReportLanguage } = useContext(ActionPlanContext);

  const isSubmitDisabled = lang === null;

  const handleFormSubmit = () => {
    if (lang !== null) {
      handleSubmit(lang);
    }
  };
  return (
    <div className="m-5">
      <div className="m-3 d-flex justify-content-center">
        <h1 className="page-title inner-title">{t('languageSelectionActionPlanTitle')}</h1>
      </div>
      <div className="m-3 d-flex justify-content-center">
        <p>{t('chooseLanguage')}</p>
      </div>

      <div className="notification-wrapper mx-2 mt-n1 d-flex justify-content-center pl-3">
        {supervisionReportLanguage && (
          <BasicNotification
            message={t('supervisionReportLanguageInfo', {
              language: t(`languageCodes.${supervisionReportLanguage}`),
            })}
            color="info"
            icon="exclamation-triangle"
          />
        )}
      </div>
      <div className="m-3 d-flex justify-content-center pl-3">
        <BasicRadioGroup
          name="select"
          elements={radItems}
          onChange={setLanguage}
          value={findMapId(radItems, lang)}
        />
      </div>

      <div className="m-3 d-flex justify-content-center">
        <Button
          text={t('createNewActionPlan')}
          onClick={handleFormSubmit}
          className="btn-primary"
          disabled={isSubmitDisabled}
        />
      </div>
    </div>
  );
};

export default NewActionPlan;
